// This function fetches nodes from the backend
export default function fetchNodes(ids: string[], getNodeTrigger: Function): Promise<Node[]> {
  return new Promise((resolve, reject) => {
    const promises = ids.map((id) => getNodeTrigger(id).unwrap());
    const nodes = Promise.all(promises);
    resolve(nodes);
  });
}
